import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from 'src/app/shared/_helpers/authentication.service';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
    selector: 'app-vss-app-layout',
    templateUrl: './vss-app-layout.component.html',
    styleUrls: ['./vss-app-layout.component.css'],
    standalone: false
})
export class VssAppLayoutComponent implements OnInit, AfterViewChecked {

  public componentTitle = 'ToDo::';
  public routerLinkArray = [];
  public icons: { [name: string]: any } = {
    'faArrowLeft': faArrowLeft
  };
  public orgName: string;

  private _orgNames: {};
  constructor(private _authenticationService: AuthenticationService, public translate: TranslateService,
    private _sharedService: SharedService, private _translateService: TranslateService, private _cdRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    const userData = this._authenticationService.currentUserDataValue;
    this.routerLinkArray = ['/vss'];
  }

  ngAfterViewChecked() {
    const currentLang = this._translateService.currentLang;
    this._sharedService.organizationNameSubject.subscribe(result => {
      if (result) {
        this.orgName = result[currentLang];
        this._orgNames = result;
        this._translateService.onLangChange.subscribe(newLang => {
          this.orgName = this._orgNames[newLang.lang];
        });
      } else {
        this.orgName = undefined;
      }
    });
    this._cdRef.detectChanges();
  }

  onLogout() {
    this._authenticationService.logout();
  }

  onLanguageChangeClick(lang) {
    this.translate.use(lang);
    localStorage.setItem('userDataLang', lang);
  }

}
